module.exports = __webpack_public_path__ + "static/003.thumb-1a7d7aca831875981231e3bd0e823c0a.jpg";